export const da = {
  back: "Tilbage",
  settings: "Indstillinger",
  deliveryToHomeAddress: "Levering til hjemmeadresse",
  title: "Titel",
  mustContainHome: 'Tekst skal indeholde ordene "MyPack Home"',
  description: "Beskrivelse",
  priceForHomeDelivery: "Pris for levering til hjemmeadresse",
  deliveryToServicePoint: "Levering til udleveringssted",
  mustContainCollect: 'Tekst skal indeholde ordene "MyPack Collect"',
  priceForCollect: "Pris for levering til udleveringssted",
  saveSettings: "Gem indstillinger",
  customerNumber: 'kundenummer'
};

export const en = {
  back: "Back",
  settings: "Settings",
  deliveryToHomeAddress: "Delivery to home address",
  title: "Title",
  mustContainHome: 'Text must contain the words "MyPack Home"',
  description: "Description",
  priceForHomeDelivery: "Price for delivery to home address",
  deliveryToServicePoint: "Delivery to collection point",
  mustContainCollect: 'Text must contain the words "MyPack Collect"',
  priceForCollect: "Price for delivery to collection point",
  saveSettings: "Save settings",
  customerNumber: 'account number'
};
